import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireDatabase } from 'angularfire2/database';
import { switchMap, map } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { isEmpty } from 'lodash';
import { combineLatest } from 'rxjs/observable/combineLatest';

@Injectable()
export class StatisticData {

  constructor(
    private afStore: AngularFirestore,
    private afDb: AngularFireDatabase
  ) { }

  public getClientStatistic(clientId: string): Observable<any> {
    return this.getClientEvent(clientId).pipe(
      switchMap((events: any[]) => {
        let obs = [];
        if (!isEmpty(events)) {
          for (let event of events) {
            obs.push(this.getEventStatistics(clientId, event.id));
          }
        }
        return isEmpty(obs) ? Observable.of([]) : combineLatest(obs)
          .pipe(map((eventsStats => {
            let index = 0;
            events.map((event) => {
              event.stats = eventsStats[index]
              index++;
            })
            return events;
          })))
      })
    )
  }

  private getClientEvent(clientId: string) {
    return this.afDb.list(`Clients/${clientId}/EventList`).valueChanges();
  }

  private getEventStatistics(clientId: string, eventId: string) {
    return this.afDb.object(`Clients/${clientId}/EventStats/${eventId}`)
      .valueChanges();
  }
}


// WEBPACK FOOTER //
// ./src/providers/statistics.ts